import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/PhoneInTalk';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from '@/components/Logo';
import { WhatsappIcon } from '@/components/WhatsappIcon';
import { whatsappLink } from '@/lib/whatsapp';
import { setting, usePublicContent } from '@/features/home/use-public-content';

export function PublicFooter() {
  const { t } = useTranslation();
  const { settings } = usePublicContent();
  const phone = setting(settings, 'company.phone', '+49 176 62655180');
  const email = setting(settings, 'company.email', 'info@planundvolt.de');
  const chat = whatsappLink(settings['company.whatsapp'], t('contact.whatsappDraft'));

  return (
    <Box component="footer" sx={{ borderTop: 1, borderColor: 'divider', py: { xs: 5, md: 7 } }}>
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 4, md: 6 }}
          justifyContent="space-between"
        >
          <Stack spacing={1.5} sx={{ maxWidth: 320 }}>
            <Logo />
            <Typography variant="body2" color="text.secondary">
              {t('footer.tagline')}
            </Typography>
          </Stack>

          <Stack spacing={1.25}>
            <Typography variant="subtitle2" component="h2">
              {t('contact.eyebrow')}
            </Typography>
            <Link href={`tel:${phone.replace(/\s/g, '')}`} color="text.secondary" variant="body2" sx={{ display: 'inline-flex', alignItems: 'center', minHeight: 24 }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <PhoneIcon fontSize="inherit" />
                <span>{phone}</span>
              </Stack>
            </Link>
            <Link href={chat} target="_blank" rel="noopener" color="text.secondary" variant="body2" sx={{ display: 'inline-flex', alignItems: 'center', minHeight: 24 }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <WhatsappIcon sx={{ fontSize: 'inherit' }} />
                <span>{t('contact.whatsappUs')}</span>
              </Stack>
            </Link>
            <Link href={`mailto:${email}`} color="text.secondary" variant="body2" sx={{ display: 'inline-flex', alignItems: 'center', minHeight: 24 }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <EmailIcon fontSize="inherit" />
                <span>{email}</span>
              </Stack>
            </Link>
          </Stack>

          <Stack spacing={1.25}>
            <Typography variant="subtitle2" component="h2">
              {t('footer.legal')}
            </Typography>
            <Link component={RouterLink} to="/impressum" color="text.secondary" variant="body2" sx={{ display: 'inline-flex', alignItems: 'center', minHeight: 24 }}>
              {t('footer.imprint')}
            </Link>
            <Link component={RouterLink} to="/datenschutz" color="text.secondary" variant="body2" sx={{ display: 'inline-flex', alignItems: 'center', minHeight: 24 }}>
              {t('footer.privacy')}
            </Link>
            <Link component={RouterLink} to="/admin/login" color="text.secondary" variant="body2" sx={{ display: 'inline-flex', alignItems: 'center', minHeight: 24 }}>
              {t('footer.adminLogin')}
            </Link>
          </Stack>
        </Stack>

        <Divider sx={{ my: { xs: 3, md: 4 } }} />
        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} Plan &amp; Volt — PV Yourself. {t('footer.rights')}
        </Typography>
      </Container>
    </Box>
  );
}
